import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { CoursePlanData } from '~/store/apis/ContractCoursePlan'

/**
 * 今月の予定情報取得
 */
import { ApiTaTp020 } from '~/endpoints/ApiTaTp020'

// State types
export interface StateScheduleForThisMonth {
  monthInformation: Array<{
    startDay: string
    endDay: string
    scheduleDetails: string
  }> | null
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}
export const getEmptyStateScheduleForThisMonth = (): StateScheduleForThisMonth => ({
  monthInformation: [],
  statusCode: 0,
  error: null,
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/ScheduleForThisMonth',
})
export default class ScheduleForThisMonth extends VuexModule {
  // States
  private state_: StateScheduleForThisMonth = getEmptyStateScheduleForThisMonth()

  // Getters

  get result(): StateScheduleForThisMonth {
    return this.state_
  }

  // Mutations

  @Mutation
  updateScheduleForThisMonth(value: StateScheduleForThisMonth) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateScheduleForThisMonth'

  // Actions

  @Action
  clear() {
    this.context.commit(ScheduleForThisMonth.MUTATION_NAME_UPDATE_STATE, getEmptyStateScheduleForThisMonth())
  }

  @Action
  async getScheduleForThisMonth(coursePlandata: CoursePlanData) {
    logger.trace('in: getScheduleForThisMonth')
    const api = new ApiTaTp020.Api()

    // API
    const result = await api.get<StateScheduleForThisMonth>(
      {
        query: coursePlandata,
      },
      // Success
      (data, status) => {
        return {
          monthInformation: data.monthInformation,
          statusCode: status,
          error: null,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return {
          monthInformation: getEmptyStateScheduleForThisMonth().monthInformation,
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateScheduleForThisMonth = getEmptyStateScheduleForThisMonth()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      if (commitdata.error === null) {
        commitdata.monthInformation = result.monthInformation
      }
    }
    this.context.commit(ScheduleForThisMonth.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
